module.exports = "<h2>{{'menu.main.delete.title' | translate}}</h2>\n\n<p>\n  {{body}}\n</p>\n\n<div class=\"action-footer\">\n  <button class=\"button secondary\" ng-click=\"cancel()\">{{'common.buttons.cancel' | translate}}</button>\n  <button class=\"button\" ng-click=\"delete()\">{{'common.buttons.delete' | translate}}</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/main/item/item.delete.modal.html
 ** module id = 618
 ** module chunks = 0
 **/